import React, { useCallback } from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import { FormControl, FormGroup } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button } from 'react-bootstrap';
import { Form, reduxForm, formValueSelector, Field, change } from 'redux-form';
import InputGroup from 'react-bootstrap/InputGroup';
import { useDispatch, useSelector } from "react-redux";

import CurrencyConverter from "../CurrencyConverter/CurrencyConverter";
import Loader from "../Common/Loader/Loader";
import InputFieldComponent from "../Common/InputFieldComponent/InputFieldComponent";

import { closeHeaderModal } from "../../actions/siteadmin/modalActions";


import { getCurrencySymbol } from "../../helpers/currencyConvertion";
import showToaster from "../../helpers/toastrMessgaes/showToaster";
import { normalizePrice } from "../../helpers/normalizeInput";
import messages from "../../locale/messages";
import validate from "./validate";
import submit from "./submit";
import { api, profilePhotouploadDir } from "../../config";

import defaultIcon from '/public/dashboard/defaultIconMenu.svg';

import bt from '../../components/commonStyle.css';
import s from './AddTipsForm.css';



function AddTipsForm({ data, currency, total, intl: { formatMessage }, handleSubmit }) {

    const dispatch = useDispatch()
    const amount = useSelector(state => formValueSelector('AddTipsForm')(state, 'amount'))
    const loading = useSelector(state => state?.loader?.cancelBooking)
    const preferredCurrency = useSelector(state => state?.userAccount?.data?.preferredCurrency)

    const handleClose = () => {
        dispatch(change('amount', null))
        dispatch(closeHeaderModal('addTipsForm'))
    }
    let symbol = getCurrencySymbol(preferredCurrency);

    const onSubmitForm = async (values) => {
        if (values.amount > total) {
            showToaster({ messageId: 'greaterTipsAmount', toasterType: 'error' });
            return;
        }

        let tipvalues = {
            ...values,
            bookingId:data?.result?.id,
            currency:preferredCurrency,
            paymentType:data?.result?.paymentType
        }

        return submit({values:tipvalues, dispatch});
    };
    
    let picture = data?.result?.partnerDetails?.picture ? api.apiEndpoint + profilePhotouploadDir + 'medium_' + data?.result?.partnerDetails?.picture : defaultIcon;
    return (
        <>
            <form onSubmit={handleSubmit(onSubmitForm)}>
                <div className={s.addTipsImageContainer}>
                    <img src={picture} width="88" height="88" alt="userProfile" />
                </div>
                <div className={cx(bt.commonSize20, bt.space4, bt.textAlignCenter, bt.fontWeight700, bt.primaryColor)}>
                    <FormattedMessage {...messages.addTips} /> {data?.result?.partnerDetails?.firstName}
                </div>
                <div className={cx(bt.space3, 'addTipsFormBox')}>
                    <Field
                        name="amount"
                        type="text"
                        component={InputFieldComponent}
                        isAddon
                        prefixLabel={symbol}
                        inputAddonContainer={cx("addTipsInputContainer")}
                        maxLength={5}
                        normalize={normalizePrice}
                    />
                </div>
                <div className={cx(bt.commonSize14, bt.fontWeight400, bt.primaryColor, bt.textAlignCenter)}>
                    <span className={bt.displayInlineBlock}><FormattedMessage {...messages.yourTipsAmountWas} />&nbsp;</span>
                    <span><CurrencyConverter amount={data?.result?.userPayableFare} from={currency} /></span>
                </div>
                <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                    <Button onClick={() => handleClose()} className={bt.btnSecondary}><FormattedMessage {...messages.cancelButton} /> </Button>
                    <Loader
                        type={"button"}
                        buttonType={'submit'}
                        show={loading}
                        label={formatMessage(messages.add)}
                        className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                    >
                    </Loader>
                </div>
            </form>
        </>
    )
}

AddTipsForm = reduxForm({
    form: 'AddTipsForm',
    destroyOnUnmount: false,
    validate

})(AddTipsForm);


export default injectIntl(withStyles(bt, s)(AddTipsForm));

